import React, { useState } from "react";
import AccommodationLine from "./AccommodationLine.js";
import LinesHandler from "./LinesHandler.js";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import bedSVG from "../svg/bed.svg";

const Accommodation = ({
  control,
  errors,
  unregister,
  setValue,
  getValues,
}) => {
  //START ADAPT TO NEW EXCEL : IT WONT SUPPORT MORE THAN ONE ACCOMMODATION WITH THE SAME TITLE//

  const [selectedAccommodations, setSelectedAccommodations] = useState([{}]);

  const handleAccommodationChange = (lineId, accomodationType, remove) => {
    setSelectedAccommodations((prevSelectedAccommodations) => {
      const updatedAccommodations = prevSelectedAccommodations.filter(
        (c) => c.lineId !== lineId
      );
      if (remove) {
        return updatedAccommodations;
      }
      return [...updatedAccommodations, { lineId, accomodationType }];
    });
  };
  //END ADAPT TO NEW EXCEL : IT WONT SUPPORT MORE THAN ONE ACCOMMODATION WITH THE SAME TITLE//
  return (
    <div className="main-card">
      <div className="card-title-box">
        <img className="svg-in-card-title" src={bedSVG} alt="accommodation" />
        <div className="card-title">Accommodation Required</div>
      </div>
      <div className="sub-card">
        <div className="mb-1">
          <LinesHandler
            lineComponent={AccommodationLine}
            lineType="accommodation"
            control={control}
            errors={errors}
            unregister={unregister}
            setValue={setValue}
            getValues={getValues}
            selectedAccommodations={selectedAccommodations}
            handleAccommodationChange={handleAccommodationChange}
          />
          <div className="my-1">
            <div className="mb-1">
              If you have any other requirements regarding accommodation, please
              share them below:
            </div>
            <Controller
              render={({ field }) => (
                <TextField
                  {...field}
                  error={Boolean(errors.extraAccommodationRequirements)}
                  helperText={
                    errors.extraAccommodationRequirements
                      ? errors.extraAccommodationRequirements.message
                      : null
                  }
                  label="Extra Requirements"
                  className="w-full"
                  multiline
                  rows={4}
                />
              )}
              name="extraAccommodationRequirements"
              control={control}
              rules={{
                maxLength: {
                  value: 500,
                  message: "Extra requirements cannot exceed 500 characters",
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accommodation;
